window.middysHawkSearchTemplates = window.middysHawkSearchTemplates || {};
window.middysHawkSearchTemplates.modifiedQuery = `
    <style>
        p {
            font-family: 'Open Sans', sans-serif;
            font-style: normal;
            font-weight: 400;
            font-size: clamp(14px, 1.4vw, 16px);
            line-height: clamp(24px, 1.4vw, 29px);
            letter-spacing: .15px;
            color: #666;
        }

        .modified-query {
            margin: 8px 0 8px 0;
        }
    </style>
    <div class="modified-query">
        <p>No results found for <strong class="modified-query__original">&#x2018;{{query}}&#x2019;</strong>. Showing results for <em class="modified-query__modified">&#x2018;{{modifiedQuery}}&#x2019;</em> instead.</p>
    </div>
`;
